import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { objectToQueryString } from "../helpers/ApiHelper";
import { IPatientTreatmentSearchParams, IPatientTreatment, ITreatmentStatus, IAccessToPatientTreatmentRelatedEntity } from "../models/IPatientTreatment";
import { ICareProvider } from "../models/ICareProvider";
import { ITreatmentType } from "../models/ITreatmentType";

export class PatientTreatmentSearchApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    searchPatientTreatments(searchParams: IPatientTreatmentSearchParams, success: (data: IPaginatedResponse<IPatientTreatment[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch?${queryString}`, success, error, final);
    }

    searchPatientTreatmentsAsExcel(searchParams: IPatientTreatmentSearchParams, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch?${queryString}&exportExcel=true`, fileName, success, error, final);
    }

    getUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch/umbrellaOgranisations`, success, error, final);
    }

    getCareProvidersByUmbrellaCareProviderId(umbrellaCareProviderId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch/careProviders/${umbrellaCareProviderId}`, success, error, final);
    }

    getTreatmentCodes(success: (data: IPatientTreatment[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch/treatmentCodes`, success, error, final);
    }

    getTreatmentTypes(success: (data: ITreatmentType[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch/treatmentTypes`, success, error, final);
    }

    getTreatmentStatuses(success: (data: ITreatmentStatus[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch/treatmentStatuses`, success, error, final);
    }

    canAccessRelatedEntity(patientTreatmentId: number, success: (data: IAccessToPatientTreatmentRelatedEntity) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IAccessToPatientTreatmentRelatedEntity>(`${Utils.LIB_API_BASE_URL}/patientTreatmentSearch/${patientTreatmentId}/canAccessRelatedEntity`, success, error, final);
    }
}